import React from 'react'
import Navbar from '../../components/shared/Navbar/Navbar'
import Footer from '../../components/shared/Footer/Footer'
import EstimatorHero from '../../components/pages/Estimator/EstimatorHero/EstimatorHero'
import EstimatorCalculator from '../../components/pages/Estimator/EstimatorCalculator/EstimatorCalculator'
import "./Estimator.css"
import EstimatorHow from '../../components/pages/Estimator/EstimatorHow/EstimatorHow'
import EstimatorBenefits from '../../components/pages/Estimator/EstimatorBenefits/EstimatorBenefits'
import AllSolutionsRequestNewProject from '../../components/pages/AllSolutions/AllSolutionsRequestNewProject/AllSolutionsRequestNewProject'
import Partners from '../../components/pages/About/Partners/Partners'
const Estimator = () => {
    const scrollToCalculator = () => {
        const target = document.getElementById("estimator-calculator");
        if (!target) return;
        target.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    return (
        <div className='estimator-page'>

            <div className="estimator-page-content-guide">
                <Navbar theme="dark" />
                <EstimatorHero onCalculateNow={scrollToCalculator} />
                <div id="estimator-calculator">
                    <EstimatorCalculator />
                </div>
                <EstimatorHow />
                <EstimatorBenefits onCalculateNow={scrollToCalculator} />
                <AllSolutionsRequestNewProject/>
                <Partners/>
            </div>
            <Footer />
        </div>
    )
}

export default Estimator